/**
 * オペレーター向けアプリの外枠。ナビと、いま開いている会社の表示。
 *
 * 顧客向けとは配信物を分け、共通部品は visumo-data-agent-web-shared 経由でだけ
 * 共有する（オペレーター専用の operation と画面を顧客向けの成果物に混ぜないため）。
 *
 * **まだ置いていない行き先**: 代行して開く導線・会社の作成と停止。
 * いずれも材料か口が無い。押しても何も起きない項目をナビに並べない。
 */

import { NavLink, Outlet } from "react-router";
import { Button, useSession } from "visumo-data-agent-web-shared";

import { useViewer } from "./ViewerContext";

const NAV_ITEMS = [
  { to: "/", label: "会社", end: true },
  { to: "/compare", label: "会社の比較", end: false },
  { to: "/semantics-fill", label: "属性の機械生成", end: false },
  { to: "/audit", label: "監査ログ", end: false },
  { to: "/account", label: "本人設定", end: false },
  { to: "/help", label: "ヘルプ", end: false },
];

export function AppShell() {
  const viewer = useViewer();
  const session = useSession();

  return (
    <div className="vd-shell">
      <nav className="vd-shell-nav" aria-label="メインナビゲーション">
        <div className="vd-shell-brand">
          <span className="vd-shell-brand-mark" aria-hidden="true" />
          visumo 管理画面(オペレーター)
        </div>
        <ul>
          {NAV_ITEMS.map((item) => (
            <li key={item.to}>
              <NavLink to={item.to} end={item.end}>
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        <div className="vd-shell-foot">
          <div>{viewer.tenant.label}</div>
          <div>{viewer.user.displayName}</div>
          <Button
            variant="text"
            style={{ marginTop: 4, paddingLeft: 0 }}
            onClick={() => session.logout()}
          >
            ログアウト
          </Button>
        </div>
      </nav>
      <main className="vd-shell-main">
        <Outlet />
      </main>
    </div>
  );
}
